(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  const slides = Array.from(track.children);
  const prevButton = document.querySelector('.prev');
  const nextButton = document.querySelector('.next');
  const dotsContainer = document.querySelector('.carousel-dots');
  let index = 0;
  let autoSlide;

  function getVisibleCount() {
    return window.innerWidth >= 768 ? 3 : 1;
  }

  function updateCarousel() {
    const slideWidth = slides[0].getBoundingClientRect().width + 20;
    track.style.transform = `translateX(-${slideWidth * index}px)`;
    updateDots();
  }

  function createDots() {
    const visible = getVisibleCount();
    dotsContainer.innerHTML = '';
    const count = slides.length - visible + 1;
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        index = i;
        resetAutoSlide();
        updateCarousel();
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    const buttons = dotsContainer.querySelectorAll('button');
    buttons.forEach((btn, i) => {
      btn.classList.toggle('active', i === index);
    });
  }

  function nextSlide() {
    const visible = getVisibleCount();
    if (index < slides.length - visible) index++;
    else index = 0;
    updateCarousel();
  }

  function prevSlide() {
    const visible = getVisibleCount();
    if (index > 0) index--;
    else index = slides.length - visible;
    updateCarousel();
  }

  nextButton.addEventListener('click', () => {
    nextSlide();
    resetAutoSlide();
  });

  prevButton.addEventListener('click', () => {
    prevSlide();
    resetAutoSlide();
  });

  // Swipe support
  let startX = 0;
  let isDragging = false;

  track.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    isDragging = true;
    clearInterval(autoSlide);
  });

  track.addEventListener('touchmove', e => {
    if (!isDragging) return;
    const x = e.touches[0].clientX;
    const dx = startX - x;
    track.style.transform = `translateX(${-dx - index * (slides[0].getBoundingClientRect().width + 20)}px)`;
  });

  track.addEventListener('touchend', e => {
    const endX = e.changedTouches[0].clientX;
    const dx = startX - endX;
    const threshold = 50;
    const visible = getVisibleCount();
    if (dx > threshold && index < slides.length - visible) index++;
    else if (dx < -threshold && index > 0) index--;
    isDragging = false;
    updateCarousel();
    resetAutoSlide();
  });

  function resetAutoSlide() {
    clearInterval(autoSlide);
    autoSlide = setInterval(nextSlide, 4000);
  }

  window.addEventListener('resize', () => {
    createDots();
    updateCarousel();
  });

  createDots();
  updateCarousel();
  resetAutoSlide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secure"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const ticker = document.getElementById('js-ticker');
  const speed = 0.5; // pixels per frame, augmente pour aller plus vite
  let pos = 0;

  // Duplicate content to allow smooth infinite scroll
  const tickerContent = ticker.innerHTML;
  ticker.innerHTML += tickerContent;

  const tickerWidth = ticker.scrollWidth / 2; // largeur du contenu original

  function animate() {
    pos -= speed;
    if (pos <= -tickerWidth) pos = 0;
    ticker.style.transform = `translateX(${pos}px)`;
    requestAnimationFrame(animate);
  }

  animate();
});

  } catch(e) { console.error(e); }
})();
})();
